import {post} from "../../../../YoubizProvider";
import cogoToast from "cogo-toast";

const etapas = [
    {
        titulo: "",
        formulario: require("./0").default
    }
];

const toastoptions = {
    hideAfter: 5,
    position: 'top-right'
}

const submeter = async (valores, opcoes) => {
    await post(`/financas/pagamentos/${opcoes.extra.id}/editar`, valores);
    cogoToast.success('Pagamento editado com sucesso', toastoptions);
};

const EditarPagamento = {
    titulo: "Editar Despesas / Prémios",
    submeter,
    etapas
};

export default EditarPagamento;